import { axios, Response } from '../index'

const updateGroupPermissions = (
  groupId: number,
  permissions: string[]
): Response<null> => {
  return axios.post(`/v1/profiles/${groupId}/permissions`, { permissions })
}

export default updateGroupPermissions
